var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgTimeSelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#E1087E"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E1087E",
    rx: 15.5
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M17 16.6V13a.968.968 0 00-.288-.713A.968.968 0 0016 12a.968.968 0 00-.713.287A.968.968 0 0015 13v3.975a1.033 1.033 0 00.3.725l2.8 2.8a.948.948 0 00.7.275.948.948 0 00.7-.275.948.948 0 00.275-.7.948.948 0 00-.275-.7L17 16.6zM16 26c-1.25 0-2.42-.238-3.512-.712a9.148 9.148 0 01-2.85-1.925 9.147 9.147 0 01-1.925-2.85A8.707 8.707 0 017 17c0-1.25.237-2.42.713-3.512a9.147 9.147 0 011.924-2.85 9.147 9.147 0 012.85-1.925A8.707 8.707 0 0116 8c1.25 0 2.42.238 3.512.713a9.147 9.147 0 012.85 1.925 9.148 9.148 0 011.926 2.85A8.707 8.707 0 0125 17c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 01-1.925 2.85 9.148 9.148 0 01-2.85 1.926A8.707 8.707 0 0116 26zM6.05 11.3a.948.948 0 01-.275-.7.95.95 0 01.275-.7L8.9 7.05a.948.948 0 01.7-.275.95.95 0 01.7.275.948.948 0 01.275.7.948.948 0 01-.275.7L7.45 11.3a.948.948 0 01-.7.275.948.948 0 01-.7-.275zm19.9 0a.948.948 0 01-.7.275.948.948 0 01-.7-.275L21.7 8.45a.948.948 0 01-.275-.7.95.95 0 01.275-.7.948.948 0 01.7-.275.95.95 0 01.7.275l2.85 2.85a.948.948 0 01.275.7.948.948 0 01-.275.7z"
  }))));
}
export default SvgTimeSelected;